import NIVEALight from '../../../assets/fonts/NIVEALight.woff2';
import NIVEARegular from '../../../assets/fonts/NIVEARegular.woff2';
import NIVEAMedium from '../../../assets/fonts/NIVEAMedium.woff2';
import NIVEABold from '../../../assets/fonts/NIVEABold.woff2';
import NIVEAExtraBold from '../../../assets/fonts/NIVEAExtraBold.woff2';

export const CssBaselineOverrides = {
  MuiCssBaseline: {
    styleOverrides: `
      @font-face {
        font-family: 'Nivea';
        font-style: normal;
        font-display: swap;
        font-weight: 300;
        src: local('Nivea'), url(${NIVEALight}) format('woff2');
      }
      @font-face {
        font-family: 'Nivea';
        font-style: normal;
        font-display: swap;
        font-weight: normal;
        src: local('Nivea'), url(${NIVEARegular}) format('woff2');
      }
      @font-face {
        font-family: 'Nivea';
        font-style: normal;
        font-display: swap;
        font-weight: 500;
        src: local('Nivea'), url(${NIVEAMedium}) format('woff2');
      }
      @font-face {
        font-family: 'Nivea';
        font-style: normal;
        font-display: swap;
        font-weight: 600;
        src: local('Nivea'), url(${NIVEABold}) format('woff2');
      }
      @font-face {
        font-family: 'Nivea';
        font-style: normal;
        font-display: swap;
        font-weight: 700;
        src: local('Nivea'), url(${NIVEAExtraBold}) format('woff2');
      }
      
    `,
  },
};
